import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckSquareOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import PropTypes from 'prop-types';

import { changeSubtaskStatus } from '../subtasks/state/subtasks.actions';
import BoardCardTaskRow from './BoardCardTaskRow';

export default function BoardCardTasks({
  taskList = [],
  variant = 'inline',
  placement = 'leftTop',
}) {
  const dispatch = useDispatch();
  const isDragging = useSelector((state) => state.boards.isDragging);

  const onStatusChange = useCallback((taskId, status) => {
    dispatch(changeSubtaskStatus(taskId, status));
  }, [dispatch]);

  if (!taskList?.length) return null;

  const taskContent = (
    <div className="board-card-tasks-content">
      {taskList.map((task) => (
        <BoardCardTaskRow
          key={task.id}
          task={task}
          onStatusChange={onStatusChange}
        />
      ))}
    </div>
  );

  if (variant === 'popover') {
    return (
      <Popover
        placement={placement}
        trigger={isDragging ? [] : ['click']}
        content={taskContent}
        overlayClassName="board-card-tasks-popover"
      >
        <span
          className="board-card-tasks-trigger"
          onClick={(e) => e.stopPropagation()}
          role="button"
          tabIndex={0}
        >
          <CheckSquareOutlined />
          <span className="board-card-days-in-status-text">{taskList.length}</span>
        </span>
      </Popover>
    )
  }

  return (
    <div
      className="board-card-tasks-inline"
      onClick={(e) => e.stopPropagation()}
      role="presentation"
    >
      {taskContent}
    </div>
  );
}

BoardCardTasks.propTypes = {
  taskList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    assigneeId: PropTypes.string,
  })),
  variant: PropTypes.oneOf(['inline', 'popover']),
  placement: PropTypes.string,
};

BoardCardTasks.defaultProps = {
  taskList: [],
  variant: 'inline',
  placement: 'leftTop',
};
